import { render, staticRenderFns } from "./EncounterReferralForm.vue?vue&type=template&id=0718b6f0&"
import script from "./EncounterReferralForm.vue?vue&type=script&lang=js&"
export * from "./EncounterReferralForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports